// extracted by mini-css-extract-plugin
export var productImage = "_n2-1";
export var viewLink = "_n2-2";
export var wishlistItem = "_n2-0";